import { Dispatch, FC, SetStateAction, MouseEvent, MutableRefObject } from 'react';
import { dashboardApi } from '#api';
import { RecipientType, NotificationReqBody, FilterFieldOptions, Notification, Status, Locale } from '#types';
import { useAppContext, useSafeState } from '#hooks';
import { notificationCodes } from '#globals';
import { HttpStatusCode } from 'axios';

interface ConfirmationSendNotificationProps {
    setIsConfirmationOpen: Dispatch<SetStateAction<boolean>>;
    notification: Notification;
    selectedDestinationName?: MutableRefObject<string | null>;
}

export const ConfirmationSendNotification: FC<ConfirmationSendNotificationProps> = ({ setIsConfirmationOpen, notification }) => {

    const { setApiStatus } = useAppContext();
    const [isLoading, setIsLoading] = useSafeState<boolean>(false)

    const handleCancel = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setIsConfirmationOpen(false);
    }

    //TODO: adjust imageUrl
    const handleSubmit = async (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        const requestBody: NotificationReqBody = { title: notification.title, body: notification.body, type: notification.type, imageUri: "welcome.png", email: notification.email };
        try {
            setIsLoading(true);
            const res = await dashboardApi.sendNotification(requestBody)
            //TODO add a status/sent boolean to the notification object
            setApiStatus({ code: res.status, message: res.data.message })
            setIsConfirmationOpen(false)
        } catch (error: any) {
            setApiStatus({ code: error?.response?.data?.statusCode, message: error?.response?.data?.message })
        } finally {
            setIsLoading(false)
        }
    };

    const highlightCodes = (text: string): JSX.Element => {
        const regexString = notificationCodes.map((code) => code.code.slice(1, -1)).join('|');
        const regex = new RegExp(`({(?:${regexString})})`, 'g');
        const parts = text.split(regex);
        return (
            <>
                {
                    parts.map(
                        (part, i) => {
                            const className = regex.test(part) ? 'highlight-accent' : '';
                            return <span className={className} key={i} >{part}</span>
                        }
                    )
                }
            </>
        );
    };

    return <div className="main-dashboard-container pd-m mt-s line-height">
        <h2>Please Check And Submit The Notification To Send</h2>
        <div className='min-width mt-m'>
            <span className='bold'>Title: </span>
            <p>{highlightCodes(notification.title)}</p>
        </div>
        <div className='min-width mt-s'>
            <span className='bold'>Body: </span>
            <span>{highlightCodes(notification.body)}</span>
        </div>
        <div className='min-width mt-s'>
            <span className='bold'>Type: </span>
            <span>{notification.type}</span>
        </div>
        {
            notification.recipients !== RecipientType.INDIVIDUAL && <div className='min-width mt-s'>
                <span className='bold'>Language: </span>
                <span>{notification.lang}</span>
            </div>
        }
        {
            isLoading ?
                <div className="lds-hourglass" /> :
                <div className="mt-m four-columns-expand-one-four">
                    <div />
                    <button onClick={handleSubmit} id='notification-confirmation-button' className='pd-s mr-m bold'>SUBMIT</button>
                    <button onClick={handleCancel} id='notification-confirmation-button' className='pd-s bold'>CANCEL</button>
                    <div />
                </div>
        }
    </div>
}
